@if (loading) {
  <div class="spinner-container">
    <app-loading-indicator />
  </div>
} @else if (!loading && error) {
  <div class="retry-container">
    <p class="retry-message">{{ errorMessage }}</p>
    <app-button innerId="btn-wTphRbMM" label="Reintentar" styleClass="primary" (action)="retryAction()" />
  </div>
} @else if (!loading && !error) {
  <ng-container>
    <ng-content></ng-content>
  </ng-container>
}
